






import { Component, Vue } from 'vue-property-decorator'
import Vehicletype from '../components/VehicleType.vue' // @ is an alias to /src

@Component({
  components: {
    Vehicletype
  },
  mounted () {
    // If you already have a vehicle type skip to step 2 because it can not be redone
    const currentVehicleType = this.$store.getters['reportVehicleType']
    if (currentVehicleType.id) {
      this.$router.push({ name: 'inspection', params: { step: '2' } })
    }
    this.$store.dispatch('updateStep', 1)
  }
})
export default class Home extends Vue {}
